import Icon from "@ant-design/icons";

const SchoolSvg = (fillOpacity = 0) => {
	return (
		<svg
			version="1.1"
			id="Capa_1"
			x="0px"
			y="0px"
			width="1em"
			height="1em"
			viewBox="0 0 31.725 31.725">
			<path
				d="M30.611,18.54v-3.817c0.708-0.605,1.113-1.479,1.113-2.415c0-1.323-0.832-2.521-2.071-2.982L18.212,5.068
		c-1.55-0.577-3.276-0.574-4.822,0.007L2.063,9.328C0.83,9.791,0,10.988,0,12.307c0,1.317,0.83,2.514,2.063,2.976L6.3,16.875
		l0.009,5.655c0.197,2.99,4.928,4.557,9.499,4.557s9.302-1.564,9.5-4.571l0.008-5.612l3.679-1.371v3.009
		c-0.545,0.395-0.892,1.165-0.892,2.015c0,1.123,0,2.284,1.699,2.284c1.698,0,1.698-1.161,1.698-2.284
		C31.503,19.706,31.157,18.935,30.611,18.54z M8.778,17.806l4.612,1.732c1.545,0.582,3.274,0.584,4.825,0.009l4.627-1.725v4.521
		c0,0.773-2.738,2.257-7.032,2.257c-4.292,0-7.031-1.481-7.031-2.257L8.778,17.806L8.778,17.806z M14.625,16.98L5.168,13.43
		c-0.085-0.032-0.19-0.068-0.308-0.107c-0.542-0.181-1.552-0.518-1.552-1.014c0-0.506,0.964-0.822,1.539-1.012
		c0.123-0.04,0.232-0.077,0.321-0.109l9.455-3.553c0.381-0.144,0.78-0.215,1.185-0.215c0.404,0,0.799,0.07,1.177,0.211l9.551,3.556
		c0.077,0.029,0.172,0.062,0.278,0.096c0.52,0.179,1.603,0.544,1.603,1.026c0,0.194-0.317,0.543-1.882,1.122l-9.549,3.554
        C16.229,17.267,15.384,17.265,14.625,16.98z"
				fill="currentColor"
			/>
		</svg>
	);
};

export const SchoolIcon = props => <Icon component={SchoolSvg.bind(this, props.fill)} {...props} />;
